import * as React from 'react';
import { styled, createTheme } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Deposits from './metricsDue.tsx';
import Orders from './metricsOrders.tsx';
import { black, fontBrand, gold, white } from '../../../../getLPTheme.tsx';
import GraficoAltaBaja from './metricsGraphicUpDown.tsx';
import ButtonMarkerExcel from '../map/mapButtonExcelContent.tsx'
import ButtonUsersExcel from '../users/userButtonExcelContent.tsx'
import TablePoints from './ListItems/itemsTableContainer.tsx'
import TableUsers from '../users/userTableContent.tsx'

const drawerWidth: number = 240;
const backgroundColorPaper = gold[100]

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export default function Dashboard() {
  const [open, setOpen] = React.useState(true);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    // <ThemeProvider theme={defaultTheme}>
      <Box sx={{ display: 'flex' }}>
          <Divider />

        <Box
          component="main"
          sx={{
            // backgroundColor: (theme) => theme.palette.grey[900],
            backgroundColor: black[1000],
            flexGrow: 1,
            // height: '100vh',
            width: {xs: 200, sm: 600, md: 900, xl: 1024, xxl: 2000},
            // overflow: 'auto',
          }}
        >
          <Typography variant="body2" textAlign="center" fontFamily={fontBrand.principal} sx={{color:"white" , fontSize: {sm: '2vw', xs: '5vw'}}}>
            Métricas Generales
          </Typography>
          <Container maxWidth="lg" sx={{ }}>
            <Grid container spacing={3}>
              {/* Chart */}
              <Grid item xs={12} md={6} lg={6}>
                <Paper
                  sx={{
                    pt: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    height: 320,
                    backgroundColor: backgroundColorPaper
                  }}
                >
                <Box>
                  <Typography sx={{fontFamily: fontBrand.principal}}>Altas y bajas de usuarios</Typography>
                  <Box sx={{display: "flex", alignItems: "center", justifyContent: "center", direction: "column"}}>
                    <GraficoAltaBaja/>
                  </Box>
                </Box>
                </Paper>
              </Grid>
              {/* Recent Deposits */}
              <Grid item xs={12} md={6} lg={6}>
                {/* <Paper sx={{p: 1,display: 'flex',flexDirection: 'column',height: 150,backgroundColor: backgroundColorPaper}}>
                  <Box>
                    <Deposits/>
                  </Box>
                </Paper> */}
                <Paper sx={{p:1, display: 'flex',flexDirection: 'column',height: 150,backgroundColor: backgroundColorPaper}}>
                  <Box sx={{display: "grid", width: '100%', alignItems: "center", justifyContent: "center", direction: "row"}}>
                    <Box sx={{width: "100%"}}>
                      <Typography sx={{fontFamily: fontBrand.principal, color: black[1000]}}>
                        Descargas
                      </Typography>
                    </Box>
                    <Box>
                      <ButtonMarkerExcel/>
                    </Box>
                    <Box>
                      <ButtonUsersExcel/>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Paper sx={{ p: 2, backgroundColor: black[1000]}}>
                  <Box>
                    <Box>
                      <Typography variant="body2" textAlign="center" fontFamily={fontBrand.principal} sx={{color:"white" , fontSize: {sm: '2vw', xs: '5vw'}}}>
                        Tabla de Puntos de Beneficios
                      </Typography>
                    </Box>
                    <Box sx={{display: "flex", alignItems: "center", justifyContent: "center", direction: "column", mt: 2}}>
                      <TablePoints/>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Paper sx={{ p: 2, backgroundColor: black[1000]}}>
                  <Box>
                    <Box>
                    <Typography variant="body2" textAlign="center" fontFamily={fontBrand.principal} sx={{color:"white" , fontSize: {sm: '2vw', xs: '5vw'}}}>
                        Tabla de Usuarios
                      </Typography>
                    </Box>
                    <Box sx={{display: "flex", alignItems: "center", justifyContent: "center", direction: "column", mt: 2}}>
                      <TableUsers/>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>
    // </ThemeProvider>
  );
}